import React from "react";
import i18next from "../localization/i18n";
import InfoIcon from "@mui/icons-material/Info";
import SaitRowAction from "./SaitRowAction";
import { saitfecoreNs } from "../utils/Constants";

/*
	Obbligatori:
		id
		onClick
	Facoltativi:
*/

export default function SaitRowActionInfo(props) {
	return SaitRowAction({
		id: props.id,
		icon: <InfoIcon color="primary" />,
		tooltip: i18next.t("information", { ns: saitfecoreNs }),
		onClick: props.onClick,
		roleSecurity: props.roleSecurity,
		objmod: props.objmod,
		hidden: props.hidden,
		endPinned: props.endPinned,
		startPinned: props.startPinned,
	});
}
